import StatefulComponent from '../../base/StatefulComponent';

export default class NotificationsCounter extends StatefulComponent
{
    init() {
        this.state = {
            count: 0
        }
    }

    render() {
        this.element.html(this.state.count);
    }
}